import * as React from 'react';
import { Controller } from "react-hook-form";
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
// import moment from 'moment';

export default function BasicDatePicker({
  isError,
  name,
  control,
  label,
  placeholder
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Controller
        name={name}
        control={control}
        render={({ field : {onChange , value } }) => (
          <DatePicker
            control={control}
            error={isError}
            label={label || "Date"}
            placeholder={placeholder || "Date"}
            onChange={onChange}
            // onChange={(event, newValue) => {
            //   console.log('newValue', newValue);
            //   const formattedDate = moment(newValue).format('MM/DD/YYYY');
            //   onChange(formattedDate);
            // }}
            value={value}
            valueDefault={null}
            disableFuture
            renderInput={(params) =>
              <TextField
                helperText="MM/DD/YYYY"
                required
                {...params}
              />}
          />
        )}
      />
    </LocalizationProvider>
  );
}
